import { useSearchParams } from 'react-router-dom';
import { FolderCard } from '~/components/FolderCard';
import type {
  ShowList__Show as Show,
  ShowList__ShowFolder as ShowFolder,
} from '../../queries/queries.generated';
import { Menu } from './ShowMenu';

export interface ShowFolderCardProps {
  showFolder: ShowFolder;
  selectedShow?: Show;
  onSelectedShow: (show: Show | undefined) => void;
}

export const ShowFolderCard = ({
  showFolder,
  selectedShow,
  onSelectedShow,
}: ShowFolderCardProps) => {
  const [searchParams] = useSearchParams();
  searchParams.set('page', '1');
  searchParams.delete('viewId');

  return (
    <FolderCard
      folder={showFolder}
      to={{ pathname: `../${showFolder.id}`, search: searchParams.toString() }}
      label="show"
    >
      <Menu item={showFolder} selectedShow={selectedShow} onSelectedShow={onSelectedShow} />
    </FolderCard>
  );
};
